// Timezone strings that already represent UTC — used to suppress the redundant
// UTC equivalent line in the event-log drawer's Event timestamp row.
// Match is case-sensitive: IANA tz IDs are canonically case-sensitive, so we don't normalize.
export const UTC_TIMEZONE_ALIASES = new Set(['UTC', 'Etc/UTC', 'GMT', 'Etc/GMT', 'Zulu']);
